import { WORKFLOW_A, WORKFLOW_B } from './roles-types';

export const screenType = {
  PANEL: 'viewer',
  PROJECT: 'rfi_module',
  OTHER: 'n/a',
};

export const emptyField = 'n/a';

export const workflowTypesMapper = {
  [WORKFLOW_A]: 'A',
  [WORKFLOW_B]: 'B',
  NONE: 'n/a',
};
